module.exports = __webpack_public_path__ + "img/Zipfelhaubenball_2018.e39ba5aa.jpg";